export const orderTypes = [
    { id: 1, label: 'Horário Planejado Partida', primary: 'DATAHORA_INICIAL_PREVISTO', secondary: null, showArrow: true },
    { id: 2, label: 'Nome da Linha', primary: 'NOMELINHA', secondary: null, showArrow: true },
    { id: 3, label: 'Cliente', primary: 'GRUPO', secondary: 'DATAHORA_INICIAL_PREVISTO', showArrow: true },
    { id: 4, label: 'Prefixo da Linha', primary: 'PREFIXO', secondary: null, showArrow: true },
    { id: 5, label: 'Veículo', primary: 'PREFIXOVEIC', secondary: 'DATAHORA_INICIAL_PREVISTO', showArrow: true }
];